import React from 'react';
import { Label } from 'semantic-ui-react';
import NameCellWrapper from '@/components/table/NameCellWrapper';
import { datasetConditionComponents } from '../containers/DatasetConditionForm';
import DatasetConditionDescription from './DatasetConditionDescription';

const DatasetConditionNameCell = ({
  datasetCondition, onClick, code, colSpan,
}) => {
  const Component = datasetConditionComponents[datasetCondition.condition.code]?.info || DatasetConditionDescription;
  const name = `${datasetCondition.condition.code}: ${datasetCondition.condition.name}`;

  return (
    <NameCellWrapper className="whitespace-normal" colSpan={colSpan}>
      <Label
        as="a"
        basic
        className="button-link"
        content={name}
        onClick={onClick}
        size="large"
        title={name}
      />
      <Component code={code} datasetCondition={datasetCondition} />
    </NameCellWrapper>
  );
};

export default DatasetConditionNameCell;
